(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mac-sports-collection"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-mac-menu-search]').forEach((input) => {
      const list = document.getElementById(input.getAttribute('aria-controls'));
      if (!list) return;
      input.addEventListener('input', () => {
        const term = input.value.trim().toLowerCase();
        list.querySelectorAll('li[data-filter-item]').forEach((item) => {
          item.hidden = term && !item.textContent.toLowerCase().includes(term);
        });
      });
    });

    document.querySelectorAll('[data-mac-variation-form]').forEach((form) => {
      form.addEventListener('submit', (event) => {
        const input = form.querySelector('[data-mac-variation-input]');
        const q = form.querySelector('input[name="q"]');
        if (!input || !q || !input.value.trim()) {
          event.preventDefault();
          return;
        }
        const sport = form.dataset.sport || '';
        const term = input.value.trim();
        q.value = sport ? `tag:${sport} "${term}"` : `"${term}"`;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mac-tcg-collection"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', () => {
  /* Sidebar search boxes */
  document.querySelectorAll('[data-mac-tcg-search]').forEach((input) => {
    const list = document.getElementById(input.getAttribute('aria-controls'));
    if (!list) return;

    input.addEventListener('input', () => {
      const term = input.value.trim().toLowerCase();

      list.querySelectorAll('li[data-filter-item]').forEach((item) => {
        item.hidden =
          term.length > 0 &&
          !item.textContent.toLowerCase().includes(term);
      });
    });
  });

  /* Multi-select checkbox filtering */
  document.querySelectorAll('[data-mac-filter-panel]').forEach((panel) => {
    const collectionUrl = panel.dataset.collectionUrl;

    const applyFilters = () => {
      const tags = [];

      panel
        .querySelectorAll('input[data-mac-filter-checkbox]:checked')
        .forEach((input) => {
          if (input.value && !tags.includes(input.value)) {
            tags.push(input.value);
          }
        });

      if (tags.length === 0) {
        window.location.href = collectionUrl;
        return;
      }

      window.location.href =
        collectionUrl.replace(/\/$/, '') + '/' + tags.join('+');
    };

    panel
      .querySelectorAll('input[data-mac-filter-checkbox]')
      .forEach((checkbox) => {
        checkbox.addEventListener('change', applyFilters);
      });

    panel
      .querySelectorAll('[data-mac-clear-all]')
      .forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          window.location.href = collectionUrl;
        });
      });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
